module.exports = __webpack_public_path__ + "assets/img/question.e6f6cf07.svg";